import Notify from "./notifyActions";

export const ARCHIVE_CHECK = 'ARCHIVE_CHECK'

export const checkArchive = (customerId) => ({
  type: ARCHIVE_CHECK,
  payload: {
    request: {
      mode: "no-cors",
      url: `archive/check?customerId=${customerId}`,
      method: "GET"
    }
  }
});

export const ARCHIVE_JOBS = "ARCHIVE_JOBS";
export const ARCHIVE_JOBS_SUCCESS_TOAST =
  "archive_jobs_success_toast";
export const ARCHIVE_JOBS_FAIL_TOAST =
  "archive_jobs_fail_toast";

export const archiveJobs = (customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ARCHIVE_JOBS,
        payload: {
          request: {
            mode: "no-cors",
            url: `archive/jobs?customerId=${customerId}`,
            method: "POST",
          }
        }
      })
        .then(response => {
          if (response.payload && response.payload.data) {
            dispatch(Notify.success(ARCHIVE_JOBS_SUCCESS_TOAST));
            resolve(response.payload);
          } else {
            dispatch(Notify.error(ARCHIVE_JOBS_FAIL_TOAST));
            resolve(response.payload);
          }
        })
        .catch(error => {
          dispatch(Notify.error(error));
          reject(error);
        });
    });
  };
};

export const ARCHIVE_REPORTS = "ARCHIVE_REPORTS";
export const ARCHIVE_REPORTS_SUCCESS_TOAST =
  "archive_reports_success_toast";
export const ARCHIVE_REPORTS_FAIL_TOAST =
  "archive_reports_fail_toast";

export const archiveReports = (customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ARCHIVE_REPORTS,
        payload: {
          request: {
            mode: "no-cors",
            url: `archive/reports?customerId=${customerId}`,
            method: "POST",
          }
        }
      })
        .then(response => {
          if (response.payload && response.payload.data) {
            dispatch(Notify.success(ARCHIVE_REPORTS_SUCCESS_TOAST));
            resolve(response.payload);
          } else {
            dispatch(Notify.error(ARCHIVE_REPORTS_FAIL_TOAST));
            resolve(response.payload);
          }
        })
        .catch(error => {
          dispatch(Notify.error(error));
          reject(error);
        });
    });
  };
};
